"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefinedTypesContentTabs = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _search = require("../../../utils/search");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ArrowDropUpV = _interopRequireDefault(require("@insided/destination/icons/ArrowDropUpV2"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _preactCompat = require("preact-compat");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FLEX_GAP = 12;
var HIDDEN_IN_DESKTOP_CLASS = 'hidden-in-desktop';

var RefinedTypesContentTabs = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(RefinedTypesContentTabs, _PureComponent);

  var _super = _createSuper(RefinedTypesContentTabs);

  function RefinedTypesContentTabs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RefinedTypesContentTabs);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "filterListRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "moreContainerRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeObserver", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mutationObserver", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hiddenItemsMap: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateHiddenElements", function () {
      var filterList = _this.filterListRef.current;

      if (!filterList) {
        return;
      }

      var hiddenItemsMap = Array.from(filterList.querySelectorAll('.instant-search__filter-tab-button')).filter(function (item) {
        return item.getBoundingClientRect().top > filterList.getBoundingClientRect().bottom;
      }).reduce(function (acc, item) {
        var tabId = item.getAttribute('tab-id');

        if (tabId) {
          acc[tabId] = true;
        }

        return acc;
      }, {});

      _this.setState({
        hiddenItemsMap: hiddenItemsMap
      }); // On reload, if the selected tab is hidden (present in dropdown), then show outside of dropdown


      var selectedTab = _this.props.tabs.find(function (tab) {
        return tab.isRefined;
      });

      if (selectedTab && _this.state.hiddenItemsMap[selectedTab.label]) {
        _this.setState({
          hiddenActiveTabLabel: selectedTab.label
        });
      }

      _this.updateMoreContainerPosition();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "debouncedMarkHiddenElements", (0, _debounce.default)(_this.updateHiddenElements, 200));
    _this.resizeObserver = new ResizeObserver(function () {
      _this.debouncedMarkHiddenElements();
    });
    _this.mutationObserver = new MutationObserver(function () {
      _this.debouncedMarkHiddenElements();
    });
    return _this;
  }

  (0, _createClass2.default)(RefinedTypesContentTabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.filterListRef.current) {
        this.resizeObserver.observe(this.filterListRef.current);
        this.mutationObserver.observe(this.filterListRef.current, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (JSON.stringify(previousProps.tabs) !== JSON.stringify(this.props.tabs)) {
        this.debouncedMarkHiddenElements();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver.disconnect();
    }
  }, {
    key: "getLastVisibleElement",
    value: function getLastVisibleElement() {
      var filterList = this.filterListRef.current;

      if (!filterList) {
        return;
      }

      var lastVisibleElement = Array.from(filterList.querySelectorAll('.instant-search__filter-tab-button')).filter(function (item) {
        return !item.classList.contains(HIDDEN_IN_DESKTOP_CLASS) && item.getBoundingClientRect().top <= filterList.getBoundingClientRect().bottom;
      }).pop();
      return lastVisibleElement;
    }
  }, {
    key: "handleDropdownClick",
    value: function handleDropdownClick(item) {
      !item.isRefined && this.props.onFilterTabChange(item);
      this.setState({
        hiddenActiveTabLabel: item.label
      });
      this.updateHiddenElements();
    }
  }, {
    key: "updateMoreContainerPosition",
    value: function updateMoreContainerPosition() {
      var _this$getLastVisibleE;

      var lastVisibleElementRect = (_this$getLastVisibleE = this.getLastVisibleElement()) === null || _this$getLastVisibleE === void 0 ? void 0 : _this$getLastVisibleE.getBoundingClientRect();

      if (this.moreContainerRef.current && lastVisibleElementRect) {
        var _this$filterListRef$c;

        var moreContainerLeft = lastVisibleElementRect.left + lastVisibleElementRect.width - (((_this$filterListRef$c = this.filterListRef.current) === null || _this$filterListRef$c === void 0 ? void 0 : _this$filterListRef$c.getBoundingClientRect().left) || 0) + FLEX_GAP;

        if (moreContainerLeft > 0) {
          this.moreContainerRef.current.style.left = moreContainerLeft + 'px';
        }
      }
    }
  }, {
    key: "renderMoreContainer",
    value: function renderMoreContainer(props) {
      var _this2 = this;

      var _this$props = this.props,
          tabs = _this$props.tabs,
          onFilterTabChange = _this$props.onFilterTabChange;
      var hiddenActiveTabLabel = this.state.hiddenActiveTabLabel;
      var hiddenActiveTab = tabs.find(function (item) {
        return item.label === hiddenActiveTabLabel;
      });
      return (0, _preact.h)("ul", (0, _extends2.default)({
        className: "more-container"
      }, props), hiddenActiveTab && (0, _preact.h)(TabButton, {
        key: hiddenActiveTab.id,
        tab: hiddenActiveTab,
        onClick: function onClick() {
          if (!hiddenActiveTab.isRefined) {
            onFilterTabChange(hiddenActiveTab);
          }
        }
      }), !(0, _isEmpty.default)(this.state.hiddenItemsMap) && (0, _preact.h)("li", null, (0, _preact.h)(_dropdown.default, {
        popupName: "some-random-name",
        triggerElement: ShowMoreButton,
        triggerClass: "dropdown-button",
        closeOnDropdownClick: true
      }, tabs.map(function (item) {
        return (0, _preact.h)("div", {
          tabIndex: 0,
          role: "button",
          key: item.id,
          hidden: !_this2.state.hiddenItemsMap[item.label],
          className: "more-dropdown-item",
          onClick: function onClick() {
            return _this2.handleDropdownClick(item);
          }
        }, (0, _search.extractLabel)(item.label, 'federated.search'), " (", item.count, ")");
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          tabs = _this$props2.tabs,
          onFilterTabChange = _this$props2.onFilterTabChange;
      var hiddenActiveTabLabel = this.state.hiddenActiveTabLabel;
      var allResultsCount = tabs.reduce(function (acc, tab) {
        return acc + tab.count;
      }, 0);
      var allResultsSelected = tabs.every(function (tab) {
        return !tab.isRefined;
      }); // const sortedItems = this.sortTabs()

      var hiddenActiveTab = tabs.find(function (item) {
        return item.label === hiddenActiveTabLabel;
      });
      return (0, _preact.h)("div", {
        className: "responsive-container"
      }, (0, _preact.h)("ul", {
        className: "instant-search__filter-list",
        ref: this.filterListRef
      }, (0, _preact.h)(TabButton, {
        key: "all-results",
        tab: {
          count: allResultsCount,
          isRefined: allResultsSelected,
          label: 'all-results',
          id: 'all-results'
        },
        onClick: function onClick() {
          if (!allResultsSelected) {
            onFilterTabChange();
          }
        }
      }, (0, _preact.h)("span", {
        className: "label-container"
      }, (0, _preact.h)(_phrase.default, {
        p: "search.allResults.label"
      }), "\xA0(", allResultsCount, ")")), tabs.map(function (item) {
        return (0, _preact.h)(TabButton, {
          key: item.id,
          tab: item,
          hidden: item.label === (hiddenActiveTab === null || hiddenActiveTab === void 0 ? void 0 : hiddenActiveTab.label),
          onClick: function onClick() {
            if (!item.isRefined) {
              onFilterTabChange(item);

              _this3.setState({
                hiddenActiveTabLabel: null
              });
            }
          }
        });
      })), this.renderMoreContainer({
        ref: this.moreContainerRef,
        style: {
          position: 'absolute'
        }
      }), this.renderMoreContainer({
        style: {
          visibility: 'hidden'
        }
      }));
    }
  }]);
  return RefinedTypesContentTabs;
}(_preactCompat.PureComponent);

exports.RefinedTypesContentTabs = RefinedTypesContentTabs;

var TabButton = function TabButton(props) {
  var tab = props.tab,
      children = props.children,
      key = props.key,
      hidden = props.hidden,
      onClick = props.onClick;
  return (0, _preact.h)("li", null, (0, _preact.h)("button", {
    key: key,
    "tab-id": tab.label,
    className: (0, _classnames2.default)('instant-search__filter-tab-button', (0, _defineProperty2.default)({
      refined: tab.isRefined
    }, HIDDEN_IN_DESKTOP_CLASS, hidden)),
    onClick: onClick
  }, !(0, _isEmpty.default)(children) ? children : (0, _preact.h)("span", {
    className: "label-container"
  }, (0, _search.extractLabel)(tab.label, 'federated.search'), "\xA0(", tab.count, ")")));
};

var ShowMoreButton = function ShowMoreButton(props) {
  return (0, _preact.h)("button", {
    onClick: props.onClick,
    disabled: props.disabled
  }, (0, _preact.h)(_phrase.default, {
    p: "search.tabFacets.more"
  }), (0, _preact.h)(_ArrowDropUpV.default, {
    width: 8,
    height: 8,
    className: "icon"
  }));
};